import { LitElement, html, css } from "lit-element";
import { repeat } from "lit-html/directives/repeat.js";
import { axios } from '@bundled-es-modules/axios';

window.smp_selected_subscription = window.smp_selected_subscription || {};
class WelcomeHeaderComponent extends LitElement {

    static get properties() {
        return {
            _MainServiceDomain: { type: String },
            _OauthServiceDomain: { type: String },
            _loginDetails: { type: Object },
            _userDetails: { type: Object },
            _subscriptionList: { type: Array },
            _updatedSubscriptionList: { type: Array },
            _subscriptionDetails: { type: Object },
            _isSelectedSubs: { type: Boolean, attribute: true },
            _subcribeLink: { type: String }
        }
    }

    get MainServiceDomain() {
        return this._MainServiceDomain;
    }

    set MainServiceDomain(value) {
        this._MainServiceDomain = value;
    }

    get OauthServiceDomain() {
        return this._OauthServiceDomain;
    }

    set OauthServiceDomain(value) {
        this._OauthServiceDomain = value;
    }

    get loginDetails() {
        return this._loginDetails;
    }

    set loginDetails(value) {
        this._loginDetails = value;
    }

    get userDetails() {
        return this._userDetails;
    }

    set userDetails(value) {
        this._userDetails = value;
    }

    get subscriptionList() {
        return this._subscriptionList;
    }

    set subscriptionList(value) {
        this._subscriptionList = value;
    }

    get updatedSubscriptionList() {
        return this._updatedSubscriptionList;
    }

    set updatedSubscriptionList(value) {
        this._updatedSubscriptionList = value;
    }

    get subscriptionDetails() {
        return this._subscriptionDetails;
    }

    set subscriptionDetails(value) {
        this._subscriptionDetails = value;
        smp_selected_subscription = this._subscriptionDetails;
    }

    get selectedSubs() {
        return this.hasAttribute('_isSelectedSubs');
    }

    set selectedSubs(boolean) {
        if (boolean) {
            this.setAttribute('_isSelectedSubs', boolean)
        } else {
            this.removeAttribute('_isSelectedSubs');
        }
    }

    get subcribeLink() {
        return this._subcribeLink;
    }

    set subcribeLink(value) {
        this._subcribeLink = value;
    }

    constructor() {
        super();
        this.selectedSubs = false;
        document.addEventListener('onUpdateAccountDetails', async(e) => {
            await this.getSubscriberDetails();
            this.dispatchEvent(new CustomEvent('onSelectSubscription', {
                bubbles: true,
                composed: true,
                detail: {
                    selectedSubscription: this.subscriptionDetails,
                    loginDetails: this.loginDetails,
                    userDetails: this.userDetails,
                }
            }));
        })
    }

    async firstUpdated() {
        if (this.getCookie("ls.authorizationData")) {
            const auth = JSON.parse(decodeURIComponent(this.getCookie("ls.authorizationData")));
            if (auth.token) {
                this.loginDetails = auth;

                if (this.loginDetails.token) {
                    await this.getSubscriberDetails();
                    const list = await this.getSubscriptionList();
                    if (list.length > 0) {
                        this.subscriptionList = list;
                        if (this.subscriptionList.length == 1) {
                            this.selectSubscription();
                        }
                    }
                }
            }
        }
    }

    updated() {
        if (!this.updatedSubscriptionList && this.subscriptionList) {
            this.updatedSubscriptionList = this.subscriptionList;
        }
    }

    static get styles() {
        return css `
        * {
            margin: 0;
            padding: 0;
        }
        .text-center {
            text-align: center;
        }

        .d-none {
            display: none;
        }
        
        .d-block {
            display: block;
        }

        .mg-b5 {
            margin-bottom: 5px;
        }
        
        .mg-t5 {
            margin-top: 5px;
        }
        
        p {
            font-size: var(--wh-p-fntSize, 18px);
        }

        .welcome-header {
            font-size: var(--widget-title-fontSize, 18px);
            color: var(--widget-title-color, #000);
            background-color: var(--widget-title-bgColor, #fff);
        }

        .btn {
            display: inline-block;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid transparent;
            padding: 6px 8px;
            font-size: 16;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn:hover, .btn:focus {
            text-decoration: none;
        }
          
        .btn:focus, .btn.focus {
            outline: 0;
            box-shadow: none;
        }
          
        .btn.disabled, .btn:disabled {
            opacity: 0.65;
        }
        
        .btn-success {
            color: var(--w-btn-col, #505050);
            background-color: var(--w-btn-bgc, #fff);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-success:hover {
            color: var(--w-btn-col, #fff);
            background-color: var(--w-btn-bgc, #505050);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-lg {
            padding: 3px;
            font-size: 14px;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn-block {
            display: block;
            width: 100%;
        }

        .error {
            font-size: var(--widget-message-fontSize, 13px);
            color: var(--widget-message-color, #000);
        }
        /*List*/
        .dropdown-toogle {
            width: 100%;
            display: block;
            padding: 10px 0;
            border-radius: 5px;
            background-color: var(--dropdown-button-bgColor, #fff);
            color:  var(--dropdown-button-Color, #000);
            font-size: var(--widget-text-fontSize, 13px);
            cursor: pointer;
            border: 1px solid #dcdcdc;
        }
        
        .dropdown-toogle:focus {
            outline: none;
            box-shadow: none;
        }

        .dropdown {
            position: relative;
            width: 59%;
            margin-left: 20px;
        }

        .subscribe-btn {
            position: relative;
            width: 10%;
            margin-left: 10px;
        }

        .dropdown-list {
            color: var(--dropdown-list-color, #000);
            background-color: var(--dropdown-list-bgColor, #fff);
            list-style: none;
            position: absolute;
            width: 100%;
            margin-top: 0px;
            box-sizing: border-box;
            box-shadow: 0 8px 20px 0 #ededed;
            border-radius: 0 0 4px 4px;
            z-index: 10;
        }
        
        .dropdown-item {
            padding: 5px;
            cursor: pointer;
            font-size: 13px;
            color: var(--dropdown-item-color, #000);
        }
        
        .dropdown-item:hover {
            background-color: var(--widget-background-bgColor, #000);
            color: #fff;
            cursor: pointer;
        }
        
        .button-arrow {
            position: relative;
            padding: 4px 16px 4px 5px;
        }

        .button-arrow:before {
            content: ' ';
            position: absolute;
            border: (--button-arrow-borderColor, #000);
            border-style: solid;
            border-width: 0 1px 1px 0;
            display: inline-block;
            padding: 3px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
            right: 10px;
            top: 8px;  
        }

        .header-dropdown-btn {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            padding-left: 3px;
            font-size: 13px;
        }

        .header-dropdown-style {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 10px;
            margin-bottom: 10px;
        }`;
    }
    getActiveIndicator(){
        return `(active)`;
    }
    getInactiveIndicator(){
        return `(inactive)`;
    }
    render() {
            return html `
        <div class="welcome-header">
         ${this.userDetails ? html`Welcome ${this.userDetails.firstName} ${this.userDetails.lastName}` : html` Welcome`}    
        <div class="header-dropdown-style">
        <p>Select Your Subscription:</p>  
        <div class="dropdown">  
        <button type="submit" class="dropdown-toogle header-dropdown-btn button-arrow" @click="${this.showList}">${this.displaySubscriptionName()}<i class="fa fa-chevron-down"></i></button>
            ${this.updatedSubscriptionList 
                ? html`<ul id="subscription-list" class="dropdown-list d-none">
                    ${repeat(this.updatedSubscriptionList,
                    (item, index) => {
                        if(item.status.toLowerCase() == 'active'){
                            return html`<li class="dropdown-item" id="new-list" @click="${this.selectSubscription}"><strong>${item.name} ${this.getActiveIndicator()}</strong></li>`
                        }else{
                            return html`<li class="dropdown-item" id="new-list" @click="${this.selectSubscription}">${item.name} ${this.getInactiveIndicator()}</li>`
                        }
                    }
                    )}</ul>` 
                : html``
            }
            </div>
        </div>
            ${this.selectedSubs && this.subscriptionDetails.status == 'Active' ?
                html`<p>Your ${this.subscriptionDetails.name} account status is <strong>${this.subscriptionDetails.status}</strong> and will renew on <strong>${this.renewalDate()}</strong></p>` : html``}
           ${this.selectedSubs && this.subscriptionDetails.status == 'Inactive' ?
                html`<div class="header-dropdown-style"><p>Your account status is inactive</p>
                <div class="subscribe-btn">
                <button type="submit" class="btn btn-success btn-lg btn-block mg-b5" @click="${this.linkToSubscribe}">Subscribe</button>
                <div></div>` : html``}
        </div>`;
    }

    renewalDate() {
        let date = new Date(this.subscriptionDetails.expirationDate);
        this.subscriptionDetails.expirationDate = new Date(this.subscriptionDetails.expirationDate);

        this.subscriptionDetails.expirationDate.setHours(0);
        this.subscriptionDetails.expirationDate.setMinutes(0);
        this.subscriptionDetails.expirationDate.setSeconds(0);

        date.setMonth(this.subscriptionDetails.expirationDate.getUTCMonth(), this.subscriptionDetails.expirationDate.getUTCDate());
        date.setFullYear(this.subscriptionDetails.expirationDate.getUTCFullYear());
        date.setHours(this.subscriptionDetails.expirationDate.getUTCHours());
        date.setMinutes(this.subscriptionDetails.expirationDate.getUTCMinutes());
        date.setSeconds(this.subscriptionDetails.expirationDate.getUTCSeconds());
        date.setMilliseconds(this.subscriptionDetails.expirationDate.getUTCMilliseconds());

        const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        return formattedDate;
    }

    getCookie(cname) {
        const name = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    async getSubscriberDetails() {
        try {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const accountDetails = await axios.get(`${this.MainServiceDomain}/appservices/api/account`, {
                headers: headers
            });

            if (accountDetails.data.UserId) {
                const res = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/subscriber/${accountDetails.data.UserId}/profile`, {
                    headers: headers
                });

                this.userDetails = res.data;
            }
        } catch (error) {
            throw error;
        }
    }

    async getSubscriptionList() {
        try {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const res = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/subscriber/${this.userDetails.subscriberId}/subscriptions?showInactive=true`, {
                headers: headers
            });

            return res.data;
        } catch (error) {
            throw error;
        }
    }

    showList() {
        if (this.subscriptionList) {
            const list = this.shadowRoot.getElementById("subscription-list");

            if (!list.classList.contains("d-none")) {
                list.classList.add("d-none");
            } else {
                list.classList.remove("d-none");
            }
        }
    }

    async selectSubscription(item) {
        if (this.subscriptionList.length == 1) {
            this.subscriptionDetails = this.subscriptionList[0];
        } else {
            const rawDisplay = this.undecorateDisplayName(item.target.innerText);
            this.subscriptionDetails = this.subscriptionList.find(i => i.name === rawDisplay);
            
            this.shadowRoot.getElementById("subscription-list").classList.add("d-none");
        }
        this.selectedSubs = true;

        this.dispatchEvent(new CustomEvent('onSelectSubscription', {
            bubbles: true,
            composed: true,
            detail: {
                selectedSubscription: this.subscriptionDetails,
                loginDetails: this.loginDetails,
                userDetails: this.userDetails
            }
        }));
        this.updatedSubscriptionList = this.subscriptionList.filter(i => i.name !== this.subscriptionDetails.name);
    }

    undecorateDisplayName(displayName){
        const activeDecorator = this.getActiveIndicator();
        const inactiveDecorator = this.getInactiveIndicator();

        const activeDecoratorStart = displayName.indexOf(activeDecorator);
        if(activeDecoratorStart > -1){
            return displayName.substring(0,activeDecoratorStart-1);
        }
        
        const inactiveDecoratorStart = displayName.indexOf(inactiveDecorator);
        if(inactiveDecoratorStart > -1){
            return displayName.substring(0,inactiveDecoratorStart-1);
        }

        return displayName;
    }

    displaySubscriptionName() {
        if (this.subscriptionDetails) {
            return this.subscriptionDetails.name;
        }
        return 'Select subscription';
    }

    linkToSubscribe() {
        window.open(this.subcribeLink);
    }
}

customElements.define('syncui-welcome-header', WelcomeHeaderComponent);